export var NavigateDataType;
(function (NavigateDataType) {
    NavigateDataType["NAVIGATE"] = "NAVIGATE";
    NavigateDataType["NAVIGATE_SUCCESS"] = "NAVIGATE_SUCCESS";
    NavigateDataType["NAVIGATE_ERROR"] = "NAVIGATE_ERROR";
    NavigateDataType["READY"] = "READY";
})(NavigateDataType || (NavigateDataType = {}));
//# sourceMappingURL=NavigateData.js.map